<template>
    <div class="timeList">
        <div class="timeList_item" v-if='isStr && !isTwo'>
            <h2>{{htmlUtil(this.title)}}</h2>
            <ul class="time_table">
                <li>时间：</li>
                <li>{{htmlUtil(this.time)}}</li>
            </ul>
            <ul class="address_table">
                <li v-if="site">地点：</li>
                <li>{{htmlUtil(this.site)}}</li>
            </ul>
        </div>
        <div class="timeList_item" v-else-if="!isStr && isTwo">
            <ul class="title_table">
                <li></li>
                <li>周一至周五</li>
                <li>周六至周日</li>
                <li>周六至周日</li>
            </ul>
            <ul class="timeList_table">
                <li>
                    <p v-for="(t,i) in title">{{t}}</p>
                </li>
                <li>
                    <p v-for="(w,i) in workday">{{w}}</p>
                </li>
                <li>
                    <p v-for="(we,i) in weekend">{{we}}</p>
                </li>
                <li :class="{flex:holiday.length==1}">
                    <p v-for="(h,i) in holiday">{{h}}</p>
                </li>
            </ul>
        </div>
        <div class="timeList_item" v-else-if="!isStr && !isTwo">
            <h2>{{ htmlUtil(this.title)}}</h2>
            <ul class="time_table">
                <li>时间：</li>
                <li class="time_sort">
                    <div><span>周一至周五</span>
                        <p>{{htmlUtil(this.workday)}}</p></div>
                    <div><span>周六至周日</span>
                        <p>{{htmlUtil(this.weekend)}}</p></div>
                    <div><span>周六至周日</span>
                        <p>{{htmlUtil(this.holiday)}}</p></div>
                </li>
            </ul>
            <ul class="address_table">
                <li>地点：</li>
                <li>{{htmlUtil(this.site)}}</li>
            </ul>
        </div>
        <!-- <div class="timeList_item" v-if='isStr'>
             <h2>{{work_time.title}}</h2>
             <ul class="time_table">
                 <li>时间：</li>
                 <li v-html="this.work_time.time"></li>
             </ul>
             <ul class="address_table">
                 <li>地点：</li>
                 <li>{{work_time.site}}</li>
             </ul>
         </div>
         <div class="timeList_item" v-else>
             <h2>{{work_time.title}}</h2>
             <ul class="time_table">
                 <li>时间：</li>
                 <li class="time_sort">
                     <div><span>周一至周五</span>
                         <p>{{work_time.time.workday}}</p></div>
                     <div><span>周六至周日</span>
                         <p>{{work_time.time.weekend}}</p></div>
                     <div><span>节假日</span>
                         <p>{{work_time.time.holiday}}</p></div>
                 </li>
             </ul>
             <ul class="address_table">
                 <li>地点：</li>
                 <li>{{htmlUtil(work_time.site)}}</li>
             </ul>
         </div>-->
    </div>
</template>

<script>
    export default {
        name: "timeList",
        props: ['work_time', 'timeIndex'],
        data: function () {
            return {
                isStr: false,
                isTwo: true,
                site: '',
                holiday: '',
                weekend: '',
                title: '',
                workday: '',
                time: '',
                length:''
            }
        },

        created: function () {
            this.title = this.work_time.title;
            this.site = this.work_time.site;
            if (typeof this.work_time.time == "string") {
                this.isStr = true;
                this.time = this.work_time.time;
            }
            if (typeof this.work_time.time == "object") {
                this.isStr = false;
                this.workday = this.work_time.time.workday;
                this.weekend = this.work_time.time.weekend;
                this.holiday = this.work_time.time.holiday;
            }
            if (this.timeIndex == '1') {
                this.isTwo = true;
                this.title = this.work_time.title.split('\n');
                console.log( this.title);
                this.workday = this.work_time.time.workday.split('<br>');
                this.weekend = this.work_time.time.weekend.split('<br>');
                this.holiday = this.work_time.time.holiday.split('<br>');


            } else {
                this.isTwo = false;
            }

            // this.htmlUtil(this.work_time);

        },
        methods: {
            htmlUtil: function (str) {
                return str.replace(/<br>/gi, "、");
                //    字符串轉行
            }
            /*  htmlUtil: function (obj) {
                  for (let i in obj) {
                      obj[i].toString().replace(/<br>/gi, "、");
                      if (typeof  obj[i] === 'object') {
                          for (let o in obj[i]) {
                              obj[i][o].toString().replace(/<br>/gi, "、");
                          }
                      }
                  }*/
            //    字符串轉行
        }
        // }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";

    .timeList {
        margin-bottom: 25px;
        width: 100%;
        background: @font-primary;
        .border-radius(10px);
        .box-sizing;
        padding: 10px 10px 20px;
        position: relative;
        h2 {
            font-size: @font;
            color: @brick_red;
            margin-bottom: 5px;
        }
        .timeList_item {
            ul {
                display: flex;
                font-size: .8rem;
                margin-bottom: 5px;
                line-height: 16px;
                li:first-child {
                    width: 12%;
                }
                li:nth-child(2) {
                    width: 88%;
                }
                &.title_table {
                    li {
                        flex: 1;
                        &:first-child {
                            flex: 1.4;
                        }
                    }
                }
                &.timeList_table {
                    li {
                        flex: 1;
                        &:first-child {
                            flex: 1.4;
                            color:@brick_red;
                            /*text-align: right;*/
                        }
                        p {
                            height: 32px;
                            @media (min-width: 320px) {
                                height: 40px;
                            }
                        }

                    }

                }

            }
            &:after {
                position: absolute;
                bottom: -10px;
                left: -1%;
                width: 102%;
                height: 36px;
                content: '';
                background: url(../../assets/images/service/work_time_1.png) no-repeat;
                z-index: 10;
                background-size: 100% auto;

            }
        }

    }

    .time_sort {
        span {
            float: left;
            width: 22%;
            @media (max-width: 378px) {
                width: 28%;
            }

        }
        p {
            width: 75%;
            @media (max-width: 378px) {
                width: 68%;
            }
            display: inline-block;

        }
    }



    .flex {
        display: flex;
        align-items: center;
    }
    @media (min-width: 768px) and (orientation: portrait) {
        .timeList {
            margin-bottom: 35px;
            padding: 15px 20px 38px;
            h2 {
                font-size: @font + .4;
                margin-bottom:10px;
            }
            .timeList_item {
                ul {

                    font-size: 1.1rem;
                    margin-bottom: 10px;
                    line-height: 24px;
                    li:first-child {
                        width: 9%;
                    }
                    li:nth-child(2) {
                        width: 88%;
                    }
                    &.title_table {
                        font-size: 1.1rem;
                        margin-bottom: 10px;
                        line-height: 24px;
                        li {
                            &:first-child {
                                flex: 1;
                            }
                        }
                    }
                    &.timeList_table {
                        li {
                            &:first-child {
                                flex: 1;
                                p {
                                    text-align: left;
                                }
                            }
                            p {
                                text-align: center;
                            }
                        }
                    }

                }
                &:after {
                    bottom: -35px;
                    left: 0;
                    width: 100%;
                    height: 78px;
                    content: '';
                    /*background: url(../../assets/images/service/work_time_1.png) no-repeat;
                    z-index: 10;
                    background-size: 100% auto;*/

                }
            }

        }

        .time_sort {
            span {
                width: 18%;
            }
            p {
                width: 79%;
            }
        }

       /* .title_table {
            font-size: 1.1rem;
            margin-bottom: 10px;
            line-height: 24px;
            li {
                &:first-child {
                    flex: 1;
                }
            }
        }
        .timeList_table {
            li {
                &:first-child {
                    flex: 1;
                    p {
                        text-align: left;
                    }
                }
                p {
                    text-align: center;
                }
            }
        }*/

    }

</style>
